// AMLR (Anti-Money Laundering Regulation) article registry
// Grouped by theme per COMP-001 requirements

export const AMLR_THEMES = [
  { id: 'RISK_ASSESSMENT', i18nKey: 'modules.bwra.compliance.themes.riskAssessment', articles: ['10', '11', '12', '13', '14', '15'] },
  { id: 'CDD', i18nKey: 'modules.bwra.compliance.themes.cdd', articles: ['16', '17', '18', '19', '20', '21'] },
  { id: 'SDD_EDD', i18nKey: 'modules.bwra.compliance.themes.sddEdd', articles: ['22', '23', '24', '25', '26'] },
  { id: 'RECORD_KEEPING', i18nKey: 'modules.bwra.compliance.themes.recordKeeping', articles: ['27', '28', '29'] },
  { id: 'BENEFICIAL_OWNERSHIP', i18nKey: 'modules.bwra.compliance.themes.beneficialOwnership', articles: ['42', '43', '44', '45', '46', '47'] },
  { id: 'REPORTING', i18nKey: 'modules.bwra.compliance.themes.reporting', articles: ['50', '51', '52', '53', '54'] },
];

export const AMLR_ARTICLES = [
  // Risk Assessment (Art. 10-15)
  {
    id: '10',
    i18nSummary: 'modules.bwra.compliance.articles.art10',
    theme: 'RISK_ASSESSMENT',
    relatedCategories: ['GEO', 'CUST', 'PROD', 'TX', 'CHAN'],
    relatedModules: ['bwra'],
  },
  {
    id: '11',
    i18nSummary: 'modules.bwra.compliance.articles.art11',
    theme: 'RISK_ASSESSMENT',
    relatedCategories: ['GEO', 'CUST', 'PROD', 'TX', 'CHAN'],
    relatedModules: ['bwra'],
  },
  {
    id: '12',
    i18nSummary: 'modules.bwra.compliance.articles.art12',
    theme: 'RISK_ASSESSMENT',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '13',
    i18nSummary: 'modules.bwra.compliance.articles.art13',
    theme: 'RISK_ASSESSMENT',
    relatedCategories: [],
    relatedModules: ['bwra', 'admin'],
  },
  {
    id: '14',
    i18nSummary: 'modules.bwra.compliance.articles.art14',
    theme: 'RISK_ASSESSMENT',
    relatedCategories: ['GEO', 'CUST', 'PROD', 'TX', 'CHAN'],
    relatedModules: ['bwra'],
  },
  {
    id: '15',
    i18nSummary: 'modules.bwra.compliance.articles.art15',
    theme: 'RISK_ASSESSMENT',
    relatedCategories: [],
    relatedModules: ['admin'],
  },
  // Customer Due Diligence (Art. 16-21)
  {
    id: '16',
    i18nSummary: 'modules.bwra.compliance.articles.art16',
    theme: 'CDD',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '17',
    i18nSummary: 'modules.bwra.compliance.articles.art17',
    theme: 'CDD',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '18',
    i18nSummary: 'modules.bwra.compliance.articles.art18',
    theme: 'CDD',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '19',
    i18nSummary: 'modules.bwra.compliance.articles.art19',
    theme: 'CDD',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '20',
    i18nSummary: 'modules.bwra.compliance.articles.art20',
    theme: 'CDD',
    relatedCategories: ['CUST', 'PROD'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '21',
    i18nSummary: 'modules.bwra.compliance.articles.art21',
    theme: 'CDD',
    relatedCategories: ['CUST', 'TX'],
    relatedModules: ['customer-risk'],
  },
  // SDD/EDD (Art. 22-26)
  {
    id: '22',
    i18nSummary: 'modules.bwra.compliance.articles.art22',
    theme: 'SDD_EDD',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '23',
    i18nSummary: 'modules.bwra.compliance.articles.art23',
    theme: 'SDD_EDD',
    relatedCategories: ['CUST', 'GEO'],
    relatedModules: ['customer-risk', 'geographical-risk'],
  },
  {
    id: '24',
    i18nSummary: 'modules.bwra.compliance.articles.art24',
    theme: 'SDD_EDD',
    relatedCategories: ['GEO'],
    relatedModules: ['geographical-risk'],
  },
  {
    id: '25',
    i18nSummary: 'modules.bwra.compliance.articles.art25',
    theme: 'SDD_EDD',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '26',
    i18nSummary: 'modules.bwra.compliance.articles.art26',
    theme: 'SDD_EDD',
    relatedCategories: ['GEO', 'CHAN'],
    relatedModules: ['geographical-risk'],
  },
  // Record Keeping (Art. 27-29)
  {
    id: '27',
    i18nSummary: 'modules.bwra.compliance.articles.art27',
    theme: 'RECORD_KEEPING',
    relatedCategories: [],
    relatedModules: ['admin'],
  },
  {
    id: '28',
    i18nSummary: 'modules.bwra.compliance.articles.art28',
    theme: 'RECORD_KEEPING',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '29',
    i18nSummary: 'modules.bwra.compliance.articles.art29',
    theme: 'RECORD_KEEPING',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  // Beneficial Ownership (Art. 42-47)
  {
    id: '42',
    i18nSummary: 'modules.bwra.compliance.articles.art42',
    theme: 'BENEFICIAL_OWNERSHIP',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '43',
    i18nSummary: 'modules.bwra.compliance.articles.art43',
    theme: 'BENEFICIAL_OWNERSHIP',
    relatedCategories: ['CUST'],
    relatedModules: [],
  },
  {
    id: '44',
    i18nSummary: 'modules.bwra.compliance.articles.art44',
    theme: 'BENEFICIAL_OWNERSHIP',
    relatedCategories: [],
    relatedModules: [],
  },
  {
    id: '45',
    i18nSummary: 'modules.bwra.compliance.articles.art45',
    theme: 'BENEFICIAL_OWNERSHIP',
    relatedCategories: ['CUST'],
    relatedModules: ['customer-risk'],
  },
  {
    id: '46',
    i18nSummary: 'modules.bwra.compliance.articles.art46',
    theme: 'BENEFICIAL_OWNERSHIP',
    relatedCategories: [],
    relatedModules: [],
  },
  {
    id: '47',
    i18nSummary: 'modules.bwra.compliance.articles.art47',
    theme: 'BENEFICIAL_OWNERSHIP',
    relatedCategories: ['CUST'],
    relatedModules: [],
  },
  // Reporting (Art. 50-54)
  {
    id: '50',
    i18nSummary: 'modules.bwra.compliance.articles.art50',
    theme: 'REPORTING',
    relatedCategories: ['TX'],
    relatedModules: [],
  },
  {
    id: '51',
    i18nSummary: 'modules.bwra.compliance.articles.art51',
    theme: 'REPORTING',
    relatedCategories: [],
    relatedModules: [],
  },
  {
    id: '52',
    i18nSummary: 'modules.bwra.compliance.articles.art52',
    theme: 'REPORTING',
    relatedCategories: ['TX'],
    relatedModules: [],
  },
  {
    id: '53',
    i18nSummary: 'modules.bwra.compliance.articles.art53',
    theme: 'REPORTING',
    relatedCategories: [],
    relatedModules: [],
  },
  {
    id: '54',
    i18nSummary: 'modules.bwra.compliance.articles.art54',
    theme: 'REPORTING',
    relatedCategories: [],
    relatedModules: [],
  },
];
